import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { COMMON_API } from '../../CommonAPI';

const Team = () => {
    const [teams, setTeams] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const token = sessionStorage.getItem("authToken");
                const response = await axios.get(`${COMMON_API}/api/team/get-team`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });
                setTeams(response.data);
            } catch (error) {
                toast.error("Error fetching teams");
            }
        };
        fetchData();
    }, []);

    const deleteTeam = async (teamId) => {
        try {
            const token = sessionStorage.getItem("authToken");
            await axios.delete(`${COMMON_API}/api/team/delete-team/${teamId}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            setTeams(prev => prev.filter(team => team.id !== teamId));
            toast.success("Deleted successfully");
        } catch (error) {
            toast.error("Error deleting team");
        }
    };

    return (
        <div className="ml-64 p-8 bg-gray-100 min-h-screen">
            <div className="flex justify-between items-center mb-6">
                <h2 className="text-3xl font-semibold text-gray-800">Team List</h2>
                <Link
                    to="/add_team"
                    className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded"
                >
                    Add Team
                </Link>
            </div>
            <div className="overflow-x-auto bg-white rounded shadow">
                <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-gray-50">
                        <tr>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">S.No</th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Name</th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Designation</th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Image</th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Content</th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">FB_link</th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Insta_link</th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Linkedin_link</th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
                        </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                        {teams.map((team, index) => (
                            <tr key={team.id}>
                                <td className="px-6 py-4 whitespace-nowrap">{index + 1}</td>
                                <td className="px-6 py-4">{team.name}</td>
                                <td className="px-6 py-4">{team.designation}</td>
                                
                                <td className="px-6 py-4">
                                    <img
                                        src={`${COMMON_API}/api/upload/${team.image}`}
                                        alt={team.image}
                                        className="w-24 h-16 object-cover rounded"
                                    />
                                </td>
                                <td className="px-6 py-4">{team.content}</td>
                                <td className="px-6 py-4">{team.fb_link}</td>
                                <td className="px-6 py-4">{team.insta_link}</td>
                                <td className="px-6 py-4">{team.linked_in_link}</td>
                                <td className="px-6 py-4 flex gap-3">
                                    <button
                                        onClick={() => deleteTeam(team.id)}
                                        className="bg-red-500 hover:bg-red-600 text-white px-3 py-1 rounded"
                                    >
                                        Delete
                                    </button>
                                    <Link
                                        to={`/edit_team/${team.id}`}
                                        className="bg-yellow-400 hover:bg-yellow-500 text-white px-3 py-1 rounded"
                                    >
                                        Edit
                                    </Link>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default Team;
 